// @ts-nocheck
/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import {
    HasProductContext,
    ProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddToCart, hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
// import React, { ChangeEvent, useEffect, useState } from "react"; Valtech Custom Code
import { connect } from "react-redux";
import { css } from "styled-components";

// Valtech Custom Code -->

import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import useAutoAdjustQuantity from "@store/Framework/Common/Hooks/useAutoAdjustQuantity";
import useHandleMinimumMultupleSalesQuantity from "@store/Framework/Common/Hooks/useHandleMinimumMultupleSalesQuantity";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import useGetInventory from "@store/Framework/Store/Data/Products/ProductsHooks/useGetInventory";

import SmallHeadingAndText from "@store/Overrides/Components/SmallHeadingAndText";

import React, { ChangeEvent, useContext, useEffect, useState } from "react";

export interface ProductQuantityOrderedProps extends Omit<OwnProps, keyof TextFieldPresentationProps> {}
// <-- Valtech Custom Code

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import useBunzlCanAddToCart from "@store//Framework/Store/Data/Products/ProductsHooks/useCanAddToCart";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useCanAddToCart, useHasEnoughInventory } from "@toolkit/Framework/Store/Data/Products/ProductsHooks";

export interface ProductQuantityOrderedProps extends Omit<OwnProps, keyof TextFieldPresentationProps> {}

export const useShowProductQuantityOrdered = (
    configurationCompleted: boolean | undefined,
    variantSelectionCompleted: boolean | undefined,
) => {
    const productContext = useContext(ProductContext);
    const { product, productInfo } = productContext;
    const hasEnoughInventory = useHasEnoughInventory(productContext);
    const canAddToCart = useCanAddToCart(product, productInfo, configurationCompleted, variantSelectionCompleted);

    return !((!hasEnoughInventory && !productInfo.failedToLoadInventory) || !canAddToCart);
};
/* Valtech Custom Code - End */
interface OwnProps extends TextFieldProps {
    configurationCompleted?: boolean;
    configurationSelection?: SafeDictionary<string>;
    variantSelectionCompleted?: boolean;
    labelOverride?: React.ReactNode;
    extendedStyles?: TextFieldPresentationProps;
    // Valtech Custom Code
    canEdit?: boolean;
}

const mapStateToProps = (
    state: ApplicationState,
    props: {
        configurationCompleted?: boolean;
        variantSelectionCompleted?: boolean;
        configurationSelection?: SafeDictionary<string>;
    } & HasProductContext,
) => {
    return {
        productSettings: getSettingsCollection(state).productSettings,
        canAddToCart: canAddToCart(
            state,
            props.productContext.product,
            props.productContext.productInfo,
            props.configurationCompleted,
            props.variantSelectionCompleted,
            props.configurationSelection,
        ),
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasProductContext;

export const productQuantityOrderedStyles: TextFieldPresentationProps = {
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                /* ISC-11023 deal with this. */
                /* stylelint-disable-next-line */
                -webkit-appearance: none;
                margin: 0;
            }
        `,
        inputSelect: css`
            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -moz-appearance: textfield;
            /* bunzl custom code */
            text-align: center;
        `,
    },
};

const ProductQuantityOrdered = ({
    productSettings,
    hasEnoughInventory,
    productContext: {
        product, // Valtech Custom Code
        onQtyOrderedChanged,
        productInfo,
    },
    labelOverride,
    extendedStyles,
    // canAddToCart,
    configurationCompleted,
    configurationSelection,
    variantSelectionCompleted,
    canEdit = true, // Valtech Custom Code
    ...otherProps
}: Props) => {
    const [styles] = useState(() => mergeToNew(productQuantityOrderedStyles, extendedStyles));
    const [productQty, setProductQty] = useState(productInfo.qtyOrdered.toString());
    const toast = useToaster();

    // Valtech Custom Code -->
    const { qtyOnHand, isWhileSuppliesLast } = useGetInventory(productInfo);
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const canAddToCart = useBunzlCanAddToCart(
        product,
        productSettings,
        productInfo,
        hasEnoughInventory,
        configurationCompleted,
        variantSelectionCompleted,
    );

    const { minimumQuantity, multipleQuantity } = useHandleMinimumMultupleSalesQuantity();
    const onAutoAdjustQuantity = (value: number) => {
        setProductQty(String(value));
        onQtyOrderedChanged && onQtyOrderedChanged(value);
    };
    const adjustQuantity = useAutoAdjustQuantity(
        Number(productQty),
        minimumQuantity,
        multipleQuantity,
        onAutoAdjustQuantity,
    );

    useEffect(() => {
        if (productInfo.qtyOrdered === Number(productQty)) {
            return;
        }

        setProductQty(`${productInfo.qtyOrdered}`);
    }, [productInfo.qtyOrdered]);

    const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === 13) {
            (event.target as any).blur();
        }
    };

    const qtyChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        // Valtech Custom Code -->
        let value = event.target.value;
        if (isWhileSuppliesLast && qtyOnHand && Number(value) > qtyOnHand) {
            value = String(qtyOnHand);
        }
        // <-- Valtech Custom Code
        setProductQty(value);

        if (!onQtyOrderedChanged) {
            logger.warn(
                `There was no onQtyOrderedChanged passed to the ProductContext for ${
                    product.id /* Valtech Custom Code */
                }`,
            );
            return;
        }

        const possibleNumber = Number(value);
        if (!Number.isNaN(possibleNumber)) {
            onQtyOrderedChanged(possibleNumber);
        }
    };

    // Valtech Custom Code
    if (!isSignedInAndhasToBeSignedIn) {
        return null;
    }
    // Valtech Custom Code

    // Valtech Custom Code --->

    /* bunzl custom code */
    const disabled = !canEdit || !canAddToCart || Boolean(productInfo.inventory?.preventAddToCart);
    return (
        <TextField
            label={labelOverride ?? translate("Qty")}
            value={productQty}
            type="number"
            min={0}
            // bunzl custom code
            step={multipleQuantity || 1}
            max={999999}
            /* bunzl custom code */
            disabled={disabled}
            data-test-selector="product_qtyOrdered"
            {...otherProps}
            onKeyPress={keyPressHandler}
            onChange={qtyChangeHandler}
            onBlur={() => adjustQuantity()} // Valtech Custom Code
            {...styles}
        />
    );

    // <--- Valtech Custom Code
};

export default withProductContext(connect(mapStateToProps)(ProductQuantityOrdered));
